import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

const NEUTRAL_AREA_CODES = new Set([
  '500', '521', '522', '523', '524', '525', '526', '527', '528', '529', '533', '544', '566',
  '577', '588', '600', '622', '633', '800', '833', '844', '855', '866', '877', '888', '900',
]);

const PROBE_SUFFIXES = ['2345678', '5550123', '3995004', '9876543'];

const buildTable = (): Map<string, CountryCode> => {
  const table = new Map<string, CountryCode>();
  for (let npa = 200; npa <= 999; npa += 1) {
    const code = String(npa);
    if (NEUTRAL_AREA_CODES.has(code)) continue;
    const countries = new Set(
      PROBE_SUFFIXES.map(suffix => parsePhoneNumberFromString(`${code}${suffix}`, 'US')?.country),
    );
    const [only] = [...countries];
    if (countries.size === 1 && only) table.set(code, only);
  }
  return table;
};

let table: Map<string, CountryCode> | null = null;

export const detectNanpCountry = (national: string): CountryCode | null => {
  if (!/^\d{3}/.test(national)) return null;
  table ??= buildTable();
  return table.get(national.slice(0, 3)) ?? null;
};
